export default function CopyOfPrivacyPolicy() {
  return (
    <div style={{ margin: '150px auto', maxWidth: '800px' }}>
      <p>Cancellation and Refund Policy</p>

      <p>This Privacy Policy was last updated on Dec 15, 2020.</p>

      <p>​</p>

      <ol>
        <li>
          <p>Cancellation by you</p>

          <ol>
            <li>
              <p>
                &nbsp;You may cancel a Monthly subscription at any time. Cancellation is effective
                at the end of the applicable monthly period. Please make any such cancellation by
                visiting here or emailing&nbsp;<a href="mailto:help@aumhum.com">help@aumhum.com</a>.
              </p>
            </li>
            <li>
              <p>
                You may cancel a Yearly subscription plan at any time. Cancellation is effective at
                the end of the applicable annual period. Additionally, our Yearly subscription plan
                is offered with a 30-day money back guarantee, which entitles you to a full refund
                upon cancellation and emailing&nbsp;
                <a href="mailto:help@aumhum.com">help@aumhum.com</a>&nbsp;to request a refund. Such
                refund requests must be made within the first 30 calendar days from your first date
                of payment. You are entitled to one refund only. After your refund, any future
                subscriptions will no longer qualify for the 30-day money back guarantee. No such
                refunds will apply to subsequent renewals of the Yearly subscription or
                subscriptions purchased through the Apple iTunes Store or our iPhone application, or
                the Google Play Store or our Android application.
              </p>
            </li>
            <li>
              <p>
                Please note that if you purchase a subscription through the Apple iTunes Store or
                our iPhone application, you may cancel your subscription by cancelling automatic
                renewal of paid In App Subscriptions by selecting Manage App Subscriptions in your
                iTunes Account settings and selecting the subscription you want to modify. If you
                purchase a subscription through the Google Play store you may cancel automatic
                renewals in account settings under Subscriptions in the Google Play app, or
                according to the current process outlined by Google Play.
              </p>
            </li>
          </ol>
        </li>
        <li>
          <p>Cancellation by US</p>

          <ol>
            <li>
              <p>
                We may suspend or terminate your use of the Products as a result of your fraud or
                breach of any obligation under these Terms. Such termination or suspension may be
                immediate and without notice. A breach of these Terms, includes without limitation,
                the unauthorized copying or download of our audio or video content from the
                Products.
              </p>
            </li>
          </ol>
        </li>
        <li>
          <p>&nbsp;Promotion and Discount Codes</p>

          <ol>
            <li>
              <p>
                Any promotion code or offer (including the Special Discount Pricing Options)
                provided by us may not be used in conjunction with any other promotion code or
                offer, past or present. Introductory offers are only available to new users of the
                Products, except where expressly stated otherwise. Previous users or trial users of
                the Products do not qualify as new users. No promotion code or discount will apply
                to corporate or other Community subscriptions. Unless otherwise set forth in the
                terms of any promotion, all pricing promotions or discounts will apply to the
                initial period of the subscription, and any renewals will be charged at the
                non-discounted rate for the type of subscription purchased.
              </p>
            </li>
          </ol>
        </li>
      </ol>

      <p>​</p>
    </div>
  )
}
